import TOS from './TOS';

export default TOS;
